module.exports = __webpack_public_path__ + "static/media/change_active.8a3d4689.svg";